import * as React from "react";
import { Component } from "react";
import CancelableAxiosInstance from "../../api/CancelableAxiosInstance";
import { LabelPartParam } from "../../api/LabelizeApi";
import { Modal, ModalHeader } from "reactstrap";
import ModalBody from "reactstrap/lib/ModalBody";
import "./image-part.scss";
import SimpleViewport from "./SimpleViewport";
import { AuthManager } from "../../component/auth/AuthContext";
import ImageUtil from "../../util/ImageUtil";
import i18n from "i18next";

interface ImagePartProps {
  client: CancelableAxiosInstance;
  imagePart: LabelPartParam;
  authManager: AuthManager;
}

interface ImagePartState {
  dataSrc?: string;
  modalOpen: boolean;
}

export default class ImagePart extends Component<ImagePartProps, ImagePartState> {
  constructor(props: ImagePartProps) {
    super(props);
    this.state = {
      modalOpen: false,
    };
  }

  componentDidMount(): void {
    this.getDataSrc(this.props.imagePart).then((dataSrc) => this.setState({ dataSrc }));
  }

  private getDataSrc(pp: LabelPartParam): Promise<string> {
    return new Promise((resolve, reject) => {
      ImageUtil.downloadImageContent(this.props.authManager.cancelableClient(), pp.imageThumbnailPath).then((data) => {
        const canvas = document.createElement("canvas");
        const context = canvas.getContext("2d");
        const imageObj = new Image();

        imageObj.onload = function () {
          const scale =
            Math.max(imageObj.naturalWidth, imageObj.naturalHeight) / Math.max(pp.imageWidth, pp.imageHeight);
          canvas.width = scale * pp.length;
          canvas.height = imageObj.naturalHeight;
          context.drawImage(imageObj, 0 - scale * pp.offset, 0);
          resolve(canvas.toDataURL());
        };

        imageObj.src = data;
      });
    });
  }

  private toggleImagePartModal(): void {
    this.setState({ modalOpen: !this.state.modalOpen });
  }

  render() {
    return (
      <div onClick={() => this.toggleImagePartModal()} className="cursor-pointer image-part">
        {this.state.dataSrc && <img className="part-img" src={this.state.dataSrc} />}

        <Modal isOpen={this.state.modalOpen} className="modal-full-size">
          <ModalHeader toggle={() => this.toggleImagePartModal()}>{i18n.t("labelize.bigSizeImage")}</ModalHeader>
          <ModalBody>
            <SimpleViewport
              imagePath={this.props.imagePart.imagePath}
              imageWidth={this.props.imagePart.imageWidth}
              imageHeight={this.props.imagePart.imageHeight}
              imageOffset={this.props.imagePart.offset}
              imageLength={this.props.imagePart.length}
              authManager={this.props.authManager}
            />
          </ModalBody>
        </Modal>
      </div>
    );
  }
}
